export class CompaniaVinculada {
    static get PROPIEDADES_EXPORTAR() {
        return [
            {
                value: "Id",
                label: "Compañía Id"
            },
            {
                value: "Nombre",
                label: "Nombre"
            },
            {
                value: "Codigo",
                label: "Código"
            },
            {
                value: "Rnc",
                label: "RNC"
            },
            {
                value: "FechaCreacion",
                label: "Fecha de Registro"
            },
            {
                value: "Email",
                label: "Correo"
            },
            {
                value: "TelefonoPrincipal",
                label: "Teléfono Principal"
            },
            {
                value: "Estatus",
                label: "Estatus"
            },
            {
                value: "PlanTransacciones",
                label: "Plan de Transacciones"
            },
            {
                value: "FechaTransaccionInicio",
                label: "Fecha Transacción Inicio"
            },
            {
                value: "FechaTransaccionFin",
                label: "Fecha Transacción Fin"
            },
            {
                value: "CantidadTransacciones",
                label: "Cantidad Transacciones"
            }
        ];
    }
}